import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { PortalAccountlistsByRealestateId } from "src/api/generated/PortalAccountlistsByRealestateId";
import { RootStoreContext } from "src/stores/RootStore";
import "src/screens/realestates/realestate/finances/Finances.css";
import { ENUM_TYPE } from "src/stores/EnumerationStore";

interface AccountlistDropdownProps {
    selectedlistid: any;
    realestateid: any;
    data: PortalAccountlistsByRealestateId;
    onChange: (newid: string) => void;
}

const AccountlistDropdownBase = (props: AccountlistDropdownProps) => {
    const { enumerationsStore } = useContext(RootStoreContext);
    const accountlistTypeMap = enumerationsStore.getEnumMapByType(ENUM_TYPE.ACCOUNTLIST_TYPES);

    const getAccountlistType = (type: number | null): string => {
        if (type === null) return "";
        return accountlistTypeMap.get(type)?.label || "";
    };

    const accountsSelectorItems: { label: string; value: string }[] = props.data.portal_accountlists.map(
        (accountlist) => {
            return {
                label: `${accountlist.title || "-"}: ${getAccountlistType(accountlist.type)}`,
                value: accountlist.id
            };
        }
    );

    const accountsSelectorLabel =
        accountsSelectorItems.find((item) => item.value === props.selectedlistid)?.label || "";

    return (
        <UI.Dropdown
            id="accountsselector"
            label={accountsSelectorLabel}
            items={accountsSelectorItems}
            onSelect={props.onChange}
        />
    );
};

export const AccountlistDropdown = Sentry.withProfiler(observer(AccountlistDropdownBase));
